import React, { useState } from 'react';

const FloatingFeedbackButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!feedback.trim()) return;

    setIsSubmitting(true);
    try {
      const response = await fetch('/feature-request/submit-api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
        body: JSON.stringify({
          feature_request: `${feedback.trim()}\n\nSubmitted from: ${window.location.href}`
        })
      });

      if (response.ok) {
        setFeedback('');
        setIsOpen(false);
        alert('Thanks! Your feedback helps us build better tools for writers.');
      } else {
        throw new Error('Failed to submit feedback');
      }
    } catch (error) {
      console.error('Feedback submission error:', error);
      alert('Failed to submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="btn btn-outline-primary shadow position-fixed d-flex align-items-center"
        style={{
          bottom: '100px',
          right: '30px',
          zIndex: 1050,
          border: '2px solid #0d6efd',
          borderRadius: '12px',
          padding: '14px 18px',
          fontSize: '15px',
          fontWeight: '500',
          backgroundColor: 'white',
          color: '#0d6efd',
          maxWidth: '200px',
          lineHeight: '1.4'
        }}
        title="Help us improve this page"
      >
        <span className="me-2">💡</span>
        <div className="text-start">
          <div style={{ fontSize: '13px', fontWeight: '600' }}>New Feature!</div>
          <div>Share Feedback</div>
        </div>
      </button>

      {/* Modal */}
      {isOpen && (
        <>
          <div 
            className="modal-backdrop fade show" 
            onClick={() => setIsOpen(false)}
            style={{ zIndex: 1040 }}
          ></div>
          <div className="modal fade show d-block" style={{ zIndex: 1050 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0 pb-2">
                  <h5 className="modal-title fw-semibold">Help Us Improve! 🎯</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsOpen(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p className="text-muted mb-3" style={{ fontSize: '15px' }}>
                    We've just launched the Portfolio feature and would love your feedback! 
                  </p>
                  <p className="text-muted small mb-3">
                    • What features are missing that you'd like to see?<br/>
                    • Any confusing or frustrating parts?<br/>
                    • What would make this page and the public profile page work better for you?
                  </p>
                  <textarea
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder="Your thoughts help us build exactly what writers need..."
                    className="form-control"
                    rows="4"
                    disabled={isSubmitting}
                  />
                </div>
                <div className="modal-footer border-0 pt-2">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => setIsOpen(false)}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={!feedback.trim() || isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Sending...
                      </>
                    ) : (
                      'Help Us Improve'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default FloatingFeedbackButton;